
import { Check, X } from 'lucide-react';
import { ReactNode } from 'react';

interface PlanFeatureProps {
  feature: string;
  description?: string | ReactNode;
  included: boolean;
}

export default function PlanFeature({ feature, description, included }: PlanFeatureProps) {
  return (
    <div className="feature-item">
      <div className="flex-shrink-0 mt-0.5">
        {included ? (
          <Check className="h-5 w-5 text-green-500" />
        ) : (
          <X className="h-5 w-5 text-brand-azul/40" />
        )}
      </div>
      <div>
        <div className="font-medium">{feature}</div>
        {description && <div className="text-sm text-brand-azul/60">{description}</div>}
      </div>
    </div>
  );
}
